export enum CanalPropostaEnum {
  RENEGOCIACAO_CALL = 'RENEGOCIACAO_CALL',
  RENEGOCIACAO_MASSIVA =  'RENEGOCIACAO_MASSIVA',
  RENEGOCIACAO_DAP_PARCELADO = 'RENEGOCIACAO_DAP_PARCELADO',
  RENEGOCIACAO_CYBER = 'RENEGOCIACAO_CYBER',
}
